import React, { useEffect, useState, useCallback } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { messList, messAttendanceList } from "../../api/Mess";
import MessLayout from "./MessLayout";

const MEAL_LABELS = {
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  full_day: "Full Day",
};

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString(undefined, {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";
const fmtTime = (t) =>
  t
    ? new Date(t).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : "-";

export default function MessAttendanceLog() {
  const [loading, setLoading] = useState(false);
  const [messes, setMesses] = useState([]);
  const [data, setData] = useState({ data: [], current_page: 1, last_page: 1 });
  const [filters, setFilters] = useState({
    from_date: new Date().toISOString().slice(0, 10),
    to_date: new Date().toISOString().slice(0, 10),
    page: 1,
  });

  const getMessList = async () => {
    try {
      const response = await messList(`&limit=all`);
      if (response.data?.status) {
        setMesses(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    }
  };

  const getDataList = useCallback(async () => {
    setLoading(true);
    let addUrl = `page=${filters.page || 1}`;
    Object.keys(filters).forEach((key) => {
      if (key === "page") return;
      const value = filters[key];
      if (value) addUrl += `&${key}=${encodeURIComponent(value)}`;
    });
    try {
      const response = await messAttendanceList(addUrl);
      if (response.data?.status) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    getMessList();
  }, []);

  useEffect(() => {
    getDataList();
  }, [getDataList]);

  const rows = data?.data ?? [];

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row py-5">
                  <MessLayout />
                  <div className="col-12">
                    <div className="card my-3">
                      <div className="card-body">
                        <h4 className="text-primary mb-0">Attendance Log</h4>
                        <div className="text-muted small mb-2">
                          Every individual mark/check-in/check-out event — for
                          audits and disputes.
                        </div>
                        <hr />
                        <div className="row align-items-center">
                          <div className="col-md-3 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={filters?.mess_id ?? ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    mess_id: e.target.value,
                                    page: 1,
                                  })
                                }
                              >
                                <option value="">All Messes</option>
                                {messes?.map((mess) => (
                                  <option key={mess.id} value={mess.id}>
                                    {mess.name}
                                  </option>
                                ))}
                              </select>
                              <label>Mess</label>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={filters?.type ?? ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    type: e.target.value,
                                    page: 1,
                                  })
                                }
                              >
                                <option value="">All Types</option>
                                <option value="Student">Student</option>
                                <option value="Staff">Staff</option>
                                <option value="Guest">Guest</option>
                              </select>
                              <label>Type</label>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={filters?.status ?? ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    status: e.target.value,
                                    page: 1,
                                  })
                                }
                              >
                                <option value="">All Status</option>
                                <option value="present">Present</option>
                                <option value="absent">Absent</option>
                              </select>
                              <label>Status</label>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                className="form-control"
                                value={filters?.from_date ?? ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    from_date: e.target.value,
                                    page: 1,
                                  })
                                }
                              />
                              <label>From</label>
                            </div>
                          </div>
                          <div className="col-md-2 col-sm-6 mb-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                className="form-control"
                                value={filters?.to_date ?? ""}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    to_date: e.target.value,
                                    page: 1,
                                  })
                                }
                              />
                              <label>To</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Date</th>
                                <th>Meal</th>
                                <th>Status</th>
                                <th>Check In</th>
                                <th>Check Out</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map((r) => (
                                <tr key={r.id}>
                                  <td>{r.enrollment?.name ?? "-"}</td>
                                  <td>{r.type}</td>
                                  <td>{fmtDate(r.attendance_date)}</td>
                                  <td>
                                    {MEAL_LABELS[r.meal_type] ?? r.meal_type}
                                  </td>
                                  <td>
                                    {r.status === "present" ? (
                                      <span className="badge bg-success">
                                        Present
                                      </span>
                                    ) : (
                                      <span className="badge bg-danger">
                                        Absent
                                      </span>
                                    )}
                                  </td>
                                  <td>{fmtTime(r.check_in_time)}</td>
                                  <td>{fmtTime(r.check_out_time)}</td>
                                </tr>
                              ))}
                              {!rows.length && (
                                <tr>
                                  <td
                                    colSpan={7}
                                    className="text-center text-muted"
                                  >
                                    No attendance records for this filter.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {data?.last_page > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-2">
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              disabled={filters.page <= 1}
                              onClick={() =>
                                setFilters({
                                  ...filters,
                                  page: (filters.page || 1) - 1,
                                })
                              }
                            >
                              Previous
                            </button>
                            <span className="text-muted">
                              Page {data.current_page} of {data.last_page}
                            </span>
                            <button
                              className="btn btn-sm btn-outline-secondary"
                              disabled={filters.page >= data.last_page}
                              onClick={() =>
                                setFilters({
                                  ...filters,
                                  page: (filters.page || 1) + 1,
                                })
                              }
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
